import React, { useEffect, useState } from "react";
import Header from "./Components/Layout/Header/NewHeader";
import Footer from "./Components/Layout/Footer/Footer";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import routes from "./routes";
import gsap from "gsap";
import "./App.css";
import cookie from "react-cookies";
// import firebase from './firebase'
import axios from "axios";
import { API_ENDPOINT } from "./AppConfig";
import { Redirect } from "react-router";
import Sockt from "./socketIo";
// import firebase from "./firebase";
// import FirebaseComponent from "./FirebaseComponent";
// import UtilSockt from "./utilsocketIo";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
export const LoginFormContext = React.createContext();
export const FormContextSignUP = React.createContext();
export const FormContextForgetPass = React.createContext();
export const FormForgetPassConfirmCode = React.createContext();
export const FormNewPassword = React.createContext();
export const FormResetPassword = React.createContext();
export const CompanyData = React.createContext();
export const ProductsData = React.createContext();
export const Category = React.createContext();
export const MainSlider = React.createContext();

export const userCookieContext = React.createContext();
export const userSessionContext = React.createContext();
export const userTokenContext = React.createContext();
export const ShoppingCart = React.createContext();
export const ChatConversation = React.createContext();
export const Notifcations = React.createContext();
export const MainHeader = React.createContext();
export const Search = React.createContext();
export const LangContext = React.createContext();

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const PublicRoute = ({ component: Component, idx, path, exact, name }) => (
  <Route
    key={idx}
    path={path}
    exact={exact}
    name={name}
    render={(props) => <Component {...props} />}
  />
);

function App() {
  const [userCookie, setUserCookie] = useState(cookie.load("CatchItUser"));
  const [lang, setLang] = useState("ar");
  const [header, setHeader] = useState(true);
  const [data, setdata] = useState(null);
  const [category, setCategory] = useState([]);
  const [slider, setSlider] = useState([]);
  const [dataProduct, setdataProduct] = useState([]);
  const [openLoginForm, setopenLoginForm] = useState(false);
  const [openFormSignUp, setopenFormSignUp] = useState(false);
  const [openFormForgetPass, setopenFormForgetPass] = useState(false);
  const [openFormConfirmCode, setopenFormConfirmCode] = useState(false);
  const [openFormNewPass, setOpenFormNewPass] = useState(false);
  const [openFormResetPassword, setopenFormResetPassword] = useState(false);
  const [userSession, setUserSession] = useState(
    JSON.parse(sessionStorage.getItem("CatchItUser"))
  );
  const [userToken, setUserToken] = useState(null);
  const [productnameFilter, setProductName] = useState([]);
  const [filterDone, setFilterDone] = useState(null);
  // const [firstTime, setfirstTime] = useState(sessionStorage.getItem('firstTime') === null ? true : false)
  const [currentPrice, setCurrentPrice] = useState(0);
  const [progressFlag, setProgressFlag] = useState(false);
  const [message, setMessage] = useState(null);
  const [locationpath, setLocationPath] = useState(null);
  // const [filterRedirect, setFilterRedirect] = useState(false)
  const [notificationCount, setnotificationCount] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [hint, setHint] = React.useState(false);
  const [UnExitProduct, setUnExitProduct] = React.useState(null);
  // const messaging = firebase.messaging();
  let currentUser_cookie = cookie.load("CatchItUser");
  let currentUser_session = JSON.parse(sessionStorage.getItem("CatchItUser"));
  let user = currentUser_session ? currentUser_session : currentUser_cookie;
  const [cart, setCart] = useState(
    cookie.load("CatchIt_Cart") ? cookie.load("CatchIt_Cart") : []
  );

  console.log("Shopper User take place ===>", user);

  // Handeling Function
  // Handel ShoppingCart is used to calaculate products in cart [MAIN Target to handel progress par that show minium amount to make order]
  const handleShoppingCart = (data) => {
    setCart(data);
    let total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].offer) {
        total =
          Number(total) +
          Number(
            parseFloat(
              (data[i].price - (data[i].offer / 100) * data[i].price).toFixed(
                2
              ) * data[i].count
            ).toFixed(2)
          );
      } else {
        total = Number(total) + Number(data[i].price * data[i].count);
      }
    }
    setCurrentPrice(total);
    setProgressFlag(true);
    localStorage.setItem("cart", JSON.stringify(data));
  };
  // ------------Function End---------------------------------

  // ---------------Function End -----------------------------------------
  // Handel Favourite
  const handleFavourite = (id, status) => {
    let object = dataProduct;
    let index = 0;
    for (var i = 0; i < object.length; i++) {
      if (object[i].id === id) {
        index = i;
      }
    }
    object[index].favorite = status;
    setdataProduct(object);
  };
  // --------------Function End ------------------------------------------

  //
  useEffect(() => {
    if (cookie.load("WebLang") === undefined) {
      cookie.save("WebLang", "ar", { path: "/" });
    } else {
    }
  }, [lang]);
  const changeLang = (str) => {
    setLang(str);
    cookie.save("WebLang", 'ar', { path: "/" });
  };

  let ua = navigator.userAgent.toLowerCase();
  console.log("ua--> ", ua.indexOf("safari") > -1);
  if (ua.indexOf("safari") > -1) {
  } else {
    var FirebaseComponent = require("./FirebaseComponent");

    Notification.requestPermission().then(
      function (permission) {
        if (!("permission" in Notification)) {
          Notification.permission = permission;
          console.log("permission--> ", Notification);
        }
        // you got permission !
      },
      function (rejection) {
        console.log("permission-->rejection ", rejection);

        // handle rejection here.
      }
    );
  }

  useEffect(() => {
    setLocationPath(window.location.pathname);
    // console.log("window.location.pathname", window.location.pathname)
  });
  useEffect(() => {
    // console.log('rkkgro-? ', cookie.load('firstTime'))
    // if (cookie.load('firstTime') === undefined) {
    //   setfirstTime(true)
    // } else {
    //   setfirstTime(false)
    // }
  }, []);
  useEffect(() => {
    if (filterDone === false) {
      let tl = gsap.timeline();
      tl.to(".PreLoading .LogoContainer", {
        ease: "Power3.inOut",
      })
        .to(".PreLoading", {
          display: "none",
          ease: "Power3.inOut",
        })
        .to(".AppStyle", {
          display: "block",
          ease: "Power3.inOut",
        });
    } else {
      let tl = gsap.timeline();
      tl.to(".PreLoading .LogoContainer", {
        ease: "Power3.inOut",
      })
        .to(".PreLoading", {
          display: "none",
          ease: "Power3.inOut",
        })
        .to(".AppStyle", {
          display: "block",
          ease: "Power3.inOut",
        });
    }
  }, [filterDone]);

  useEffect(() => {
    // Lang
    if (cookie.load("WebLang") === undefined) {
      cookie.save("WebLang", "ar", { path: "/" });
      setLang("en");
    } else {
      setLang(cookie.load("WebLang"));
    }
    setHeader(
      JSON.parse(localStorage.getItem("Header"))
        ? JSON.parse(localStorage.getItem("Header"))
        : true
    );
    setCart(
      JSON.parse(localStorage.getItem("cart"))
        ? JSON.parse(localStorage.getItem("cart"))
        : []
    );
    handleShoppingCart(
      JSON.parse(localStorage.getItem("cart"))
        ? JSON.parse(localStorage.getItem("cart"))
        : []
    );
    fetch();

    // messaging.requestPermission().then(() => {
    //     return messaging.getToken();
    //   })
    //   .then((token) => {
    //   })
    //   .catch((err) => {
    //   });
    // messaging.onMessage((payload) => {
    // });
  }, [lang]);

  const handelPath = (data) => {
    setLocationPath(data);
  };
  const handleIntroFilter = () => {
    setFilterDone(!filterDone);
    sessionStorage.setItem("firstTime", JSON.stringify("false"));
    // fetchProducts();
  };
  const handelProgressFlag = (flag) => {
    setProgressFlag(flag);
  };

  const ToggleLoginForm = () => {
    setopenLoginForm(!openLoginForm);
    setopenFormForgetPass(false);
  };
  const ToggleForm_signUp = () => {
    setopenFormSignUp(!openFormSignUp);
  };
  const ToggleForm_forgetPass = () => {
    setopenFormForgetPass(!openFormForgetPass);
  };
  const ToggleForm_forgetPass_ConfirmCode = () => {
    setopenFormConfirmCode(!openFormConfirmCode);
  };
  const ToggleForm_newPass = () => {
    setOpenFormNewPass(!openFormNewPass);
  };
  const ToggleForm_ResetPassword = () => {
    setopenFormResetPassword(!openFormResetPassword);
  };
  const handelChat = (data) => {
    setMessage(data);
  };
  const handelpage = (data) => {
    // console.log("data take place in header ===>",data)
    setHeader(data);
    localStorage.setItem("Header", data);
  };
  const handelNotificationCount = (data) => {
    setnotificationCount(data);
  };
  const fetch = () => {
    let url = `${API_ENDPOINT}/companies?removeLanguage=true`;

    axios
      .get(url, { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        console.log(
          "Result res Take place companies===",
          lang,
          response.data.data
        );
        setdata(response.data.data[0]);
        if (response.data.data[0].hideBranchesPage === false) {
          setFilterDone(true);
          // sessionStorage.setItem('firstTime', JSON.stringify('false'))
        } else {
          setFilterDone(false);
        }
      })
      .catch((error) => {
        // console.log("Result Take place Error===", error.response)
      });
  };

  const handleUserCookie = () => {
    let temp = cookie.load("CatchItUser");
    console.log("temp===>",temp)
    setUserCookie(temp);
  };
  const handleUserSession = () => {
    let temp = JSON.parse(sessionStorage.getItem("CatchItUser"));
    setUserSession(temp);
  };

  const handleUserToken = (str) => {
    setUserToken(str);
  };

  const handelFilter = (filterName) => {
    console.log("dddd-> ", filterName, typeof filterName);
    if (filterName !== "") {
      if (typeof filterName === "object") {
        setProductName(filterName);
      } else if (typeof filterName === "string") {
        // when search by product name is not exist in the system
        // with forward to all products page so will show
        // all products contain this word (filterName)

        setUnExitProduct(filterName);
        setHint(
          lang === "ar"
            ? "هذا المنتج غير متوفر حاليا"
            : "This product is currently out of the stock"
        );
        setOpen(true);
      }
    } else {
      setHint(
        lang === "ar"
          ? "هذا المنتج غير متوفر حاليا"
          : "This product is currently out of the stock"
      );
      setOpen(true);
    }
  };

  const clearSearchResult = () => {
    setProductName([]);
    setUnExitProduct(null);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <LangContext.Provider value={{ lang: "ar", changeLang: changeLang }}>
      <MainHeader.Provider value={{ handelpage: handelpage }}>
        <userCookieContext.Provider
          value={{ userCookie: userCookie, handleUserCookie: handleUserCookie }}
        >
          <userSessionContext.Provider
            value={{
              userSession: userSession,
              handleUserSession: handleUserSession,
            }}
          >
            <userTokenContext.Provider
              value={{ userToken: userToken, handleUserToken: handleUserToken }}
            >
              <ShoppingCart.Provider
                value={{
                  cart: cart,
                  flag: progressFlag,
                  total: currentPrice,
                  handelProgressFlag: handelProgressFlag,
                  handleShoppingCart: handleShoppingCart,
                }}
              >
                <ProductsData.Provider
                  value={{
                    dataProducts: dataProduct,
                    handleFavourite: handleFavourite,
                  }}
                >
                  <Category.Provider value={{ category: category }}>
                    <Notifcations.Provider
                      value={{
                        count: notificationCount,
                        handelNotificationCount: handelNotificationCount,
                      }}
                    >
                      <Search.Provider
                        value={{
                          search: productnameFilter,
                          clearSearchResult: clearSearchResult,
                        }}
                      >
                        <MainSlider.Provider value={{ slider: slider }}>
                          <CompanyData.Provider value={{ data: data }}>
                            <ChatConversation.Provider
                              value={{
                                chat: message,
                                handelChat: handelChat,
                              }}
                            >
                              {/* {sessionStorage.getItem("firstTime") === null && (
                                <Preloading />
                              )} */}

                              {user && (
                                <Sockt
                                  serverUrl="https://amanah.app:9000/chat"
                                  newMessage="NewMessage"
                                  id={user.id}
                                />
                              )}

                              {/* {user && (
                                <UtilSockt
                                  serverUrl="https://amanah.app:9000/utils"
                                  Notifytopic="NotificationsCount"
                                  id={user.id}
                                />
                              )} */}
                              <LoginFormContext.Provider
                                value={{
                                  openLoginForm: openLoginForm,
                                  ToggleLoginForm: ToggleLoginForm,
                                }}
                              >
                                <FormContextSignUP.Provider
                                  value={{
                                    openFormSignUp: openFormSignUp,
                                    ToggleForm_signUp: ToggleForm_signUp,
                                  }}
                                >
                                  <FormContextForgetPass.Provider
                                    value={{
                                      openFormForgetPass: openFormForgetPass,
                                      ToggleForm_forgetPass: ToggleForm_forgetPass,
                                    }}
                                  >
                                    <FormForgetPassConfirmCode.Provider
                                      value={{
                                        openFormConfirmCode: openFormConfirmCode,
                                        ToggleForm_forgetPass_ConfirmCode: ToggleForm_forgetPass_ConfirmCode,
                                      }}
                                    >
                                      <FormNewPassword.Provider
                                        value={{
                                          openFormNewPass: openFormNewPass,
                                          ToggleForm_newPass: ToggleForm_newPass,
                                        }}
                                      >
                                        <FormResetPassword.Provider
                                          value={{
                                            openFormResetPassword: openFormResetPassword,
                                            ToggleForm_ResetPassword: ToggleForm_ResetPassword,
                                          }}
                                        >
                                          <div
                                            style={{
                                              direction:
                                                lang === "ar" ? "rtl" : "ltr",
                                              textAlign:
                                                lang === "ar"
                                                  ? "right"
                                                  : "left",
                                            }}
                                          >
                                            <BrowserRouter>
                                              {/* {user &&
                                                (ua.indexOf("safari") >
                                                -1 ? null : (
                                                  <FirebaseComponent />
                                                ))} */}

                                              <div
                                                className="AppStyle"
                                                style={{
                                                  direction:
                                                    lang === "ar"
                                                      ? "rtl"
                                                      : "ltr",
                                                  textAlign:
                                                    lang === "ar"
                                                      ? "right"
                                                      : "left",
                                                }}
                                              >
                                                <Header
                                                  header={header}
                                                  handelFilter={handelFilter}
                                                  locationpath={locationpath}
                                                  shoppingCardCount={
                                                    cart.length
                                                  }
                                                  notification={
                                                    notificationCount
                                                  }
                                                />
                                                <Snackbar
                                                  open={open}
                                                  autoHideDuration={6000}
                                                  onClose={handleClose}
                                                >
                                                  <Alert severity="error">
                                                    {hint}
                                                  </Alert>
                                                </Snackbar>

                                                <div className="appRouteStyle">
                                                  {productnameFilter &&
                                                  productnameFilter.length >
                                                    0 ? (
                                                    <Route>
                                                      <Redirect
                                                        to={{
                                                          pathname: `/Catch-It/Product/${productnameFilter[0].id}`,
                                                          state: {
                                                            data:
                                                              productnameFilter[0],
                                                          },
                                                        }}
                                                      />
                                                    </Route>
                                                  ) : null}
                                                  {UnExitProduct !== null ? (
                                                    <Route>
                                                      <Redirect
                                                        to={{
                                                          pathname: `/Catch-It/All-Product`,
                                                          state: {
                                                            searchby: UnExitProduct,
                                                          },
                                                        }}
                                                      />
                                                    </Route>
                                                  ) : null}

                                                  {window.location.pathname ===
                                                  "/" ? (
                                                    <Route>
                                                      <Redirect to="/Catch-It" />
                                                    </Route>
                                                  ) : null}

                                                  <Switch>
                                                    {routes.map(
                                                      (route, idx) => {
                                                        return (
                                                          <PublicRoute
                                                            path={route.path}
                                                            idx={idx}
                                                            exact={route.path}
                                                            name={route.name}
                                                            component={
                                                              route.component
                                                            }
                                                          />
                                                        );
                                                      }
                                                    )}
                                                  </Switch>
                                                </div>
                                                <Footer
                                                  handelPath={handelPath}
                                                />
                                              </div>
                                            </BrowserRouter>
                                          </div>
                                        </FormResetPassword.Provider>
                                      </FormNewPassword.Provider>
                                    </FormForgetPassConfirmCode.Provider>
                                  </FormContextForgetPass.Provider>
                                </FormContextSignUP.Provider>
                              </LoginFormContext.Provider>
                            </ChatConversation.Provider>
                          </CompanyData.Provider>
                        </MainSlider.Provider>
                      </Search.Provider>
                    </Notifcations.Provider>
                  </Category.Provider>
                </ProductsData.Provider>
              </ShoppingCart.Provider>
            </userTokenContext.Provider>
          </userSessionContext.Provider>
        </userCookieContext.Provider>
      </MainHeader.Provider>
    </LangContext.Provider>
  );
}
export default App;
